import { createContext, useContext } from "react";

/**
 * Opt-in "dense" mode for long forms.
 *
 * The long, multi-section forms (institution / organisation registration, the
 * credential add/edit forms) scroll off-screen at the default comfortable
 * spacing. Wrapping their content in <DenseForm> flips this context to true;
 * the shared form primitives (LineField, MonthYearPicker, FileUpload) read it
 * and switch to tighter spacing/sizing so the whole form fits on a typical
 * screen without scrolling.
 *
 * Defaults to false, so every form that does NOT opt in keeps the original
 * comfortable layout.
 */
const FormDensityContext = createContext(false);

export function DenseForm({ children }) {
  return (
    <FormDensityContext.Provider value={true}>
      {children}
    </FormDensityContext.Provider>
  );
}

export function useDense() {
  return useContext(FormDensityContext);
}
